import usersPlot from "../../../../content/posts/blogs/2022/two-years-nextflow/users.jsx";
import committersPlot from "../../../../content/posts/blogs/2022/two-years-nextflow/committers.jsx";
import * as React from 'react';
export default {
  usersPlot,
  committersPlot,
  React
};